module.exports = __webpack_public_path__ + "static/media/benchmark-3-bg.b25a77c4.svg";